var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { FieldValidationRule } from './components';
import { FieldValidationRuleStates, ValidationChecklistTestIdFactory, } from './interactions';
import styles from './ValidationChecklist.module.css';
export const ValidationChecklist = ({ 'data-testid': testid, errors, rules, }) => {
    return (_jsx("ul", { className: styles.Container, "data-testid": ValidationChecklistTestIdFactory.getValidationChecklistListTestId(testid), children: rules.map((rule, index) => {
            const isSatisfied = rule.errorCodes.every((ruleErrorCode) => errors.every((error) => error.code !== ruleErrorCode));
            return (_jsx(FieldValidationRule, { "data-test-state": isSatisfied
                    ? FieldValidationRuleStates.Correct
                    : FieldValidationRuleStates.Incorrect, "data-testid": ValidationChecklistTestIdFactory.internalGenerateValidationChecklistRuleItemTestId(testid, index), isSatisfied: isSatisfied, label: rule.label }, rule.label));
        }) }));
};
_react_refresh_temp_1 = ValidationChecklist;
$RefreshReg$(_react_refresh_temp_1, "ValidationChecklist");
